export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20geometric%20background%20with%20warm%20coral%20and%20amber%20gradients%2C%20subtle%20wave%20patterns%2C%20modern%20editorial%20design%2C%20dark%20moody%20atmosphere%20with%20warm%20accent%20lighting%2C%20stylized%20and%20artistic%20texture%2C%20no%20realistic%20objects&width=1800&height=900&seq=hero-bg-2026-x1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="inline-flex items-center gap-1.5 bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 text-primary-200 text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap">
                <i className="ri-fire-line text-sm"></i>
                实时更新
              </span>
              <span className="inline-flex items-center gap-1.5 bg-accent-500/20 backdrop-blur-sm border border-accent-400/30 text-accent-200 text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap">
                <i className="ri-flashlight-line text-sm"></i>
                51吃瓜同步
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-4">
              黑料爆料 · 娱乐圈吃瓜第一站
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-heading mb-6">
              一手黑料，新鲜大瓜，吃瓜群众每日必刷
            </p>

            <div className="space-y-2 md:space-y-3 mb-6 text-white/70 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0">
              <p>
                黑料爆料吃瓜网专注娱乐圈八卦与明星黑料热门大瓜，每日追踪最新负面新闻、绯闻爆料和社会热点。
                17c与51吃瓜实时同步，为您打造一站式的吃瓜体验——无论是顶流塌房、剧组内幕还是网红翻车，
                这里都是吃瓜群众不可错过的第一现场。
              </p>
              <p>
                当前热门：多位顶流艺人私生活争议持续发酵，某综艺节目录制现场突发纠纷引发全网讨论，
                社交平台多起明星小号曝光事件正在深度追踪中。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-300">2000+</div>
                <div className="text-xs md:text-sm text-white/60">累计爆料</div>
              </div>
              <div className="w-px h-8 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-300">24h</div>
                <div className="text-xs md:text-sm text-white/60">全天候更新</div>
              </div>
              <div className="w-px h-8 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-300">100万+</div>
                <div className="text-xs md:text-sm text-white/60">月活跃吃瓜群众</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-surgical-mask-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white border border-white/30 font-semibold px-8 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bar-chart-2-line text-lg"></i>
                查看热度榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20magazine%20collage%20with%20floating%20newspaper%20fragments%2C%20warm%20coral%20and%20amber%20tones%2C%20dramatic%20lighting%2C%20modern%20editorial%20design%2C%20dynamic%20composition%20with%20scattered%20text%20elements%2C%20artistic%20texture%2C%20no%20human%20faces%2C%20dark%20background&width=800&height=600&seq=hero-visual-2026-x2&orientation=landscape"
                alt="黑料爆料吃瓜网 - 娱乐八卦热点聚焦"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex flex-wrap gap-2">
                <span className="bg-primary-500/90 text-white text-xs px-2.5 py-1 rounded-full whitespace-nowrap">明星黑料</span>
                <span className="bg-accent-500/90 text-white text-xs px-2.5 py-1 rounded-full whitespace-nowrap">娱乐圈八卦</span>
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs px-2.5 py-1 rounded-full whitespace-nowrap">51吃瓜</span>
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs px-2.5 py-1 rounded-full whitespace-nowrap">17c吃瓜</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}